import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-96a3b408")

_pushScopeId("data-v-96a3b408")
const _hoisted_1 = { class: "item-title" }
const _hoisted_2 = { class: "float-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.subName), 1)
  ]))
})